import { useMediaQuery } from "@mantine/hooks";

/**
 * The control size for the current viewport: 36px on desktop, 42px on a phone.
 *
 * One hook rather than a judgement call in every file. The brief sets both
 * numbers (theme.other.controlHeight / controlHeightTouch) and the reason for
 * the larger one is not aesthetics: a 36px target is below what a thumb hits
 * reliably, and the people using the phone screens are doing it one-handed at
 * a customer's gate.
 *
 * Deliberately keyed on WIDTH, not on a touch-capability test. A touch laptop
 * is still a desktop layout, and a phone held in landscape is still a phone.
 *
 * Returns "md" (42px) while the media query is still resolving - server-side
 * and on the first paint useMediaQuery reports undefined, and starting large
 * then shrinking is safer than starting small on a device that needed large.
 */
export function useControlSize(): "sm" | "md" {
  const isDesktop = useMediaQuery("(min-width: 48em)");
  return isDesktop ? "sm" : "md";
}
